var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.944,
    height: 16.945,
    viewBox: "0 0 16.944 16.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warehouse",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M16.545,21.942H11.78a.53.53,0,0,1-.53-.53V17.53a.53.53,0,0,1,.53-.53h4.766a.53.53,0,0,1,.53.53v3.883A.53.53,0,0,1,16.545,21.942Zm-4.236-1.059h3.707V18.059H12.309Z",
    transform: "translate(-3.307 -4.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M13.119,16.3H8.53a.53.53,0,0,1-.53-.53V11.53A.53.53,0,0,1,8.53,11h4.589a.53.53,0,0,1,.53.53v4.236A.53.53,0,0,1,13.119,16.3Zm-4.06-1.059h3.53V12.059H9.059Z",
    transform: "translate(-2.352 -3.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M9.8,21.942H5.03a.53.53,0,0,1-.53-.53V17.53A.53.53,0,0,1,5.03,17H9.8a.53.53,0,0,1,.53.53v3.883A.53.53,0,0,1,9.8,21.942ZM5.559,20.883H9.266V18.059H5.559Z",
    transform: "translate(-1.323 -4.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M11.78,13.118a.53.53,0,0,1-.53-.53V11.53a.53.53,0,0,1,1.059,0v1.059A.53.53,0,0,1,11.78,13.118Z",
    transform: "translate(-3.307 -3.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M8.53,19.118a.53.53,0,0,1-.53-.53V17.53a.53.53,0,0,1,1.059,0v1.059A.53.53,0,0,1,8.53,19.118Z",
    transform: "translate(-2.352 -4.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M15.03,19.118a.53.53,0,0,1-.53-.53V17.53a.53.53,0,0,1,1.059,0v1.059A.53.53,0,0,1,15.03,19.118Z",
    transform: "translate(-4.263 -4.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M15.709,16.944H1.236A1.237,1.237,0,0,1,0,15.708V6a.53.53,0,0,1,.229-.436L8.172.093a.528.528,0,0,1,.6,0l7.943,5.472A.532.532,0,0,1,16.944,6v9.708a1.237,1.237,0,0,1-1.236,1.236ZM1.059,6.279v9.429a.177.177,0,0,0,.177.177H15.709a.177.177,0,0,0,.177-.177V6.279L8.472,1.172Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.52019a7e2c7f054fab7ac290c8ef3f59.svg";
export { ForwardRef as ReactComponent };